import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { openExternalUrl } from "./openExternalUrl";

/**
 * Hook that returns a navigation function which automatically handles:
 * - Native app: Opens URLs in external browser (for payment compliance)
 * - Web: Uses React Router navigation
 *
 * @param externalUrls - Array of path patterns that should always open externally in native app
 * @returns A function that navigates to the given path appropriately
 */
export const useSmartNavigate = () => {
  const navigate = useNavigate();

  return (path: string) => {
    if (Capacitor.isNativePlatform()) {
      // Check if this is an event/payment-related path
      if (
        path.toLowerCase().match(/^\/event\/atlanta\//) ||
        path.toLowerCase().match(/^\/spark\/atlanta\//)
      ) {
        // openExternalUrl is async, but we don't await it here
        // to keep the API simple and non-blocking
        openExternalUrl(path).catch((error) => {
          console.error("Failed to open external URL:", error);
        });
      } else {
        navigate(path);
      }
    } else {
      navigate(path);
    }
  };
};
